import React from 'react';

const TableDataSizePerPage = ({onChange}) => {
    return (
        <div className="select-container">
            <div className="select" onChange={(e) => onChange(e)} style={{maxWidth: "150px"}}>
                <select className="select-text" required="">
                    <option value="5"> 5</option>
                    <option value="10"> 10</option>
                    <option value="15"> 15</option>
                </select>
                <label className="select-label">Show Entries</label>
            </div>
        </div>
    );
};

export default TableDataSizePerPage;
